/*
 * @Description: 订单信息编辑
 * @Author: 杨志航
 * @Date: 2026-07-07 15:46:23
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Spin,
  message,
  Drawer,
} from 'antd'
import { allTrim, filterParams, cryptoParamsIntoUrl, getMethodExport } from '@/utils'
import { Link } from 'react-router-dom'
import Import from '@/components/Import'
import EditForm from './module/EditForm'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const sourceSystemList = [{
  id: 1,
  name: '易企信',
}, {
  id: 2,
  name: '老OA',
}]
const payTypeList = [{
  id: 1,
  name: '正常收款',
}, {
  id: 2,
  name: '负利',
}, {
  id: 3,
  name: '厂商直汇',
}, {
  id: 5,
  name: '负利收款',
}, {
  id: 6,
  name: '负利收款(直汇)',
}, {
  id: 10,
  name: '厂商赠送',
}]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const InfoEdit = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [visibleFile, setVisibleFile] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const ImportRef = useRef(null)

  useEffect(() => {
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    const params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    if (Object.keys(params).length === 0) return
    setLoading(true)
    api.getAvailableOrderList(searchParams).then(res => {
      const { list, total } = res
      setList(list)
      setCount(total)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    setList([])
    setCount(0)
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 导出
  const exportFile = () => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    params.export = 1
    setSpinLoading(true)
    getMethodExport('/fortune/Order/GetAvailableOrderList', params).then(() => {
      setSpinLoading(false)
    }).catch(() => setSpinLoading(false))
  }

  //导入
  const onImportFile = () => {
    setVisibleFile(true)
    ImportRef.current.onRemoved()
  }

  const doImport = (fileList) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        const { url } = fileList[0]
        api.importOrderPortAndVendor({
          path: url,
        }).then(() => {
          message.success('导入成功')
          ImportRef.current.onLoading()
          onReset()
          setVisibleFile(false)
        }).catch(() => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  const handleEdit = (record) => {
    setEditData(record)
    setEditVisible(true)
  }

  return <>
    <Spin spinning={spinLoading}>
      <div className="search-doc-wrap">
        <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
          <div className="form-box">
            <FormItem label="订单编号">
              {getFieldDecorator('number')(<Input placeholder="请输入订单编号" />)}
            </FormItem>
            <FormItem label="客户/代理商名称">
              {getFieldDecorator('clientName')(<Input placeholder="请输入客户/代理商名称" />)}
            </FormItem>
            <FormItem label="客户/代理商ID">
              {getFieldDecorator('clientId')(<Input placeholder="请输入客户/代理商ID" />)}
            </FormItem>
            <FormItem label="厂商ID">
              {getFieldDecorator('vendorId')(<Input placeholder="请输入厂商ID" />)}
            </FormItem>
            <FormItem label="端口识别号">
              {getFieldDecorator('portIdentify')(<Input placeholder="请输入端口识别号" />)}
            </FormItem>
            <FormItem label="端口名称">
              {getFieldDecorator('portName')(<Input placeholder="请输入端口名称" />)}
            </FormItem>
            <FormItem label="原始厂商ID">
              {getFieldDecorator('originalVendorId')(<Input placeholder="请输入原始厂商ID" />)}
            </FormItem>
            <FormItem label="订单负责人">
              {getFieldDecorator('staffName')(<Input placeholder="请输入订单负责人" />)}
            </FormItem>
            <FormItem label="来源系统">
              {getFieldDecorator('sourceSystem')(<Select
                placeholder="请选择"
                allowClear
              >
                {
                  sourceSystemList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="收款类型">
              {getFieldDecorator('payType')(<Select
                placeholder="请选择"
                allowClear
              >
                {
                  payTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="供应商">
              {getFieldDecorator('supplier')(<Input placeholder="请输入供应商" />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          <Button type="primary" onClick={onImportFile}>信息导入</Button>
          <Button type="primary" onClick={exportFile} style={{ marginLeft: 15 }}>数据导出</Button>
        </div>
        <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
          scroll={{ x: 'max-content' }}
        >
          <Column 
            title="序号" 
            dataIndex="id"
            fixed="left"
            render={(text, record, index) => count - ((currentPage - 1) * pageSize + index)} 
          />
          <Column 
            title="订单编号" 
            dataIndex="adr_number" 
            fixed="left"
            render={(text, record) => (
              <>
                {record.sourceSystem === '易企信' ? (
                  <Link 
                    to={cryptoParamsIntoUrl(record.adr_customertype === 1 ? '/orderDirect/directDetail' : '/orderAgent/agentDetail', { id: record.adr_faorderId })} 
                    target="_blank"
                  >
                    {text}
                  </Link>
                ) : text}
              </>
            )}
          />
          <Column title="客户/代理商名称" dataIndex="customerName" />
          <Column title="客户/代理商ID" dataIndex="adr_oaid" />
          <Column title="厂商ID" dataIndex="adr_cid" />
          <Column title="端口识别号" dataIndex="adr_port_identify" />
          <Column title="端口名称" dataIndex="adr_port_name" />     
          <Column title="原始厂商ID" dataIndex="adr_original_vendor_id" />
          <Column 
            title="合同编号" 
            dataIndex="contractNo" 
            render={(text, record) => text || '-'}
          />
          <Column title="订单负责人" dataIndex="staffName" />
          <Column title="来源系统" dataIndex="sourceSystem" />
          <Column title="收款类型" dataIndex="payTypeName" />
          <Column title="可用消耗" dataIndex="adr_available" />
          <Column title="供应商" dataIndex="supplier" />
          <Column title="操作"
            key="set" 
            fixed="right"
            align="center"
            width={80}
            render={(text, record) =>
              <a onClick={() => handleEdit(record)}>编辑</a>
            }
          />
        </Table>
      </div>
    </Spin>
    <Import
      onSearch={doImport}
      visibleFile={visibleFile}
      onCloseImport={() => setVisibleFile(false)}
      ImportTemplate="/api/File/DownTemplate?url=/templates/订单信息导入模板.xlsx&name=订单信息导入模板"
      ImportRef={ImportRef}
    />
    <Drawer
      title="订单信息编辑"
      width={600}
      onClose={() => setEditVisible(false)}
      visible={editVisible}
      destroyOnClose={true}
    >
      <EditForm 
        setVisible={setEditVisible}
        editData={editData}
        getList={getList}
      />
    </Drawer>
  </>
}

export default Form.create()(InfoEdit)
